"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _localization = require("@lt/localization");
var _HotelCardFact = _interopRequireDefault(require("./HotelCardFact"));
var _HotelLine = _interopRequireDefault(require("../../icons-react/hotel-facts/HotelLine1"));
var _HotelLine2 = _interopRequireDefault(require("../../icons-react/hotel-facts/HotelLine2"));
var _HotelLine3 = _interopRequireDefault(require("../../icons-react/hotel-facts/HotelLine3"));
var TOOLTIP = _localization.i18n.t('hotelcard.facts.beach_line.tooltip');
var LABEL = _localization.i18n.t('hotelcard.facts.beach_line.label');
var ICONS = [_HotelLine["default"], _HotelLine2["default"], _HotelLine3["default"]];
var makeIcon = function makeIcon(line) {
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var IconComp = ICONS[line - 1];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(IconComp, null), /*#__PURE__*/_react["default"].createElement("span", null, "".concat(line).concat(t('hotelcard.facts.beach_line.line'))));
};
var HotelBeachLine = function HotelBeachLine(_ref) {
  var value = _ref.value,
    className = _ref.className;
  return value ? /*#__PURE__*/_react["default"].createElement(_HotelCardFact["default"], {
    className: className,
    tooltip: TOOLTIP,
    label: LABEL,
    icon: makeIcon(value)
  }) : null;
};
HotelBeachLine.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].number
};
HotelBeachLine.defaultProps = {
  className: '',
  value: null
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelBeachLine);